import React, { useState } from 'react';
import "../SubSidebar.scss";
import { Button } from '@mui/material';

interface SidebarProps {
  onSelect: (component: string) => void;
}

const InnerSidebar: React.FC<SidebarProps> = ({ onSelect }) => {
  // State to track which button is selected
  const [activeButton, setActiveButton] = useState<string>("general");

  // Function to handle button click and set the active button
  const handleButtonClick = (component: string) => {
    setActiveButton(component);
    onSelect(component); // Trigger the onSelect callback
  };

  return (
    <div className="inner-sidebar">
      <Button
        variant="text" // Text-only button
        className={`sidebar-btn ${activeButton === 'general' ? 'active' : ''}`}
        onClick={() => handleButtonClick('general')}
      >
        General
      </Button>
      <Button 
        variant="text" // Text-only button
        className={`sidebar-btn ${activeButton === 'appTokens' ? 'active' : ''}`}
        onClick={() => handleButtonClick('appTokens')}
      >
        App Tokens
      </Button>
    </div>
  );
};

export default InnerSidebar;
